<template>
  <confirmation-modal v-if="isConfirmationModalOpen"
                      @cancel="isConfirmationModalOpen = false"
                      @confirm="closeModal"
                      :modal-header-text="isBetDiscussion 
                        ? 'Czy na pewno chcesz opuścić okno dodawania wpisu?'
                        : 'Czy na pewno chcesz opuścić okno dodawania typu?'"
                      :cancel-button-text="'Zostań'"
                      :confirm-button-text="'Opuść'"
                      :modal-body-text="'Twoje dane zostaną utracone!'">
  </confirmation-modal>
  <div ref="backdrop" class="z-backdrop fixed left-0 top-0 w-full h-full outline-none overflow-y-overlay !bg-black/40 xl:px-0">
    <div v-click-outside="clickOutside"
         class="mx-auto fixed bg-zt-normal shadow-zt h-full w-full xl:rounded-md xl:h-fit xl:!relative xl:max-w-[624px]"
         :class="[
           { 'xl:translate-y-[140px]': isBetDiscussion },
           window.PHP.visibleAdminBar ? 'top-8 xl:top-[112px]' : 'top-0 xl:top-[80px]'
         ]">
      <div class="flex items-center px-5 py-4 border-b border-zt-light">
        <span class="font-semibold">{{ 'Dodawanie nowego ' + (isBetDiscussion ? 'wpisu' : 'typu') }}</span>
        <div class="x-close-modal !z-backdrop" @click="openConfirmationModal($event)"></div>
      </div>
      <div class="flex flex-col overflow-x-hidden overflow-y-auto px-2 xl:overflow-y-visible"
           :class="window.PHP.visibleAdminBar ? 'h-[calc(100%-80px)]' : 'h-[calc(100%-50px)]'">
        <div class="flex-1 pt-3">
          <div class="flex flex-col gap-2.5">
            <div class="flex items-center gap-1 xl:justify-center">
              <span class="text-sm font-semibold ml-1.5 text-left xl:text-center xl:ml-0">
                {{ isBetDiscussion ? 'W którym wpisie ma się pojawić post?' : 'Wybierz dzień wydarzenia' }}
              </span>
              <div v-if="!isBetDiscussion" class="inline relative cursor-pointer zt-hover"
                   @click="hideTooltip"
                   data-bs-trigger="click" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-custom-class="modal-tooltip"
                   title="Na każdy dzień można dodać max. 2 typy. Liczy się dzień meczu/wydarzenia, a nie publikacji typu na stronie">
                <svg class="ml-0.5 w-4 h-4 rotate-180" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.5013 21.0837C12.76 21.0853 14.0067 20.8382 15.1696 20.3564C16.3325 19.8747 17.3888 19.1679 18.2777 18.2767C19.1689 17.3878 19.8757 16.3316 20.3574 15.1686C20.8391 14.0057 21.0863 12.7591 21.0846 11.5003C21.0862 10.2416 20.8391 8.99495 20.3574 7.83204C19.8757 6.66912 19.1689 5.61286 18.2777 4.72396C17.3888 3.83272 16.3325 3.12594 15.1696 2.64422C14.0067 2.16251 12.76 1.91537 11.5013 1.917C10.2426 1.9154 8.99593 2.16255 7.83301 2.64426C6.6701 3.12597 5.61384 3.83274 4.72493 4.72396C3.83372 5.61286 3.12695 6.66912 2.64524 7.83204C2.16353 8.99495 1.91637 10.2416 1.91798 11.5003C1.91635 12.7591 2.16349 14.0057 2.6452 15.1686C3.12691 16.3316 3.8337 17.3878 4.72493 18.2767C5.61384 19.1679 6.6701 19.8747 7.83301 20.3564C8.99593 20.8381 10.2426 21.0853 11.5013 21.0837Z" stroke="#93A3BA" stroke-width="2" stroke-linejoin="round" />
                  <circle cx="11.5" cy="16.6" r="1.1" fill="#93A3BA" />
                  <path d="M11.5 5.75V13.4167" stroke="#93A3BA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
            <div class="flex flex-col justify-center gap-1">
              <div class="flex justify-center items-center gap-x-2 rounded-zt xl:mx-[62px]"
                   :class="[checkErrors('date') ? ['outline', 'outline-1', 'outline-[#FF1818]', 'outline-offset-4'] : '']">
                <button class="w-full h-[35px] border border-zt-light rounded-zt text-xs font-semibold zt-hover"
                        :class="{ 'bg-zt-light': dateOffset === 0 }" @click="setBetDate(0)">
                  {{ parseDate(0) }}
                </button>
                <button class="w-full h-[35px] border border-zt-light rounded-zt text-xs font-semibold zt-hover"
                        :class="{ 'bg-zt-light': dateOffset === 1 }" @click="setBetDate(1)">
                  {{ parseDate(1) }}
                </button>
                <button class="w-full h-[35px] border border-zt-light rounded-zt text-xs font-semibold zt-hover"
                        :class="{ 'bg-zt-light': dateOffset === 2 }" @click="setBetDate(2)">
                  {{ parseDate(2) }}
                </button>
              </div>
              <div class="text-center">
                <span class="error-text" v-for="error in errors.filter(e => e.type === 'date')">{{ error.content }}</span>
              </div>
            </div>
          </div>
          <div class="grid gap-x-5 gap-y-[22px] pt-3">
            <div v-if="!isBetDiscussion && comment_type.string !== 'Komentarz'" class="relative col-span-2 xl:col-span-1">
              <label class="bet-element-header text-left">Dyscyplina</label>
              <FootballSelect
                  :height="45"
                  :padding="14"
                  is-model-object
                  v-model="discipline"
                  :default="'Wybierz dyscyplinę'"
                  :options="disciplines.map(disc => disc.title)"
              />
              <div class="flex">
                <span class="absolute error-text" v-for="error in errors.filter(e => e.type === 'discipline')">
                  {{ error.content }}
                </span>
              </div>
            </div>
            <div v-if="!isBetDiscussion && comment_type.string !== 'Komentarz'" class="relative col-span-2 xl:col-span-1">
              <label for="match-name" class="bet-element-header text-left">Wydarzenie</label>
              <input class="min-h-[45px]" :class="[checkErrors('name') ? ['border', 'border-[#FF1818]'] : '']"
                     type="text" id="match-name" placeholder="Wpisz wydarzenie (max 100 znaków)" v-model="match_name"
                     maxlength="100" :disabled="comment_type.string === 'Komentarz'" />
              <div class="flex flex-col">
                <span class="absolute error-text" v-for="error in errors.filter(e => e.type === 'name')">
                  {{ error.content }}
                </span>
              </div>
            </div>
            <div v-if="!isBetDiscussion && comment_type.string !== 'Komentarz'" class="relative col-span-2 xl:col-span-1">
              <div class="w-full flex justify-between">
                <label for="type" class="bet-element-header text-left">Typ</label>
                <div class="flex text-xs items-center gap-x-[6px]">
                  Betbuilder
                  <div
                      @click="isBetbuilder = !isBetbuilder"
                      class="flex items-center gap-2.5 font-light w-5 h-5 cursor-pointer zt-hover text-[#EEE]">
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="0.5" y="0.5" width="24" height="24" rx="4.5" :fill="isBetbuilder ? '#FF4A5D' : '#3A4B6459'" />
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.38985 15.9466L5.30791 12.2349L3.94727 13.4721L9.38985 18.4211L21.0525 7.81621L19.6919 6.57898L9.38985 15.9466Z"
                            :fill="isBetbuilder ? 'white' : 'transparent'" />
                      <rect x="0.5" y="0.5" width="24" height="24" rx="4.5" :stroke="isBetbuilder ? '#9B2733' : '#3A4B64'" />
                    </svg>
                  </div>
                </div>
              </div>
              <input class="min-h-[45px]" :class="[checkErrors('type') ? ['border', 'border-[#FF1818]'] : '']"
                     type="text" id="type" v-model="type" maxlength="100" placeholder="Podaj typ (max 100 znaków)"
                     :disabled="comment_type.string === 'Komentarz'" />
              <div class="flex flex-col">
                <span v-if="isBetbuilder"
                      :class="{ '!text-[#F00]' : errors.filter(e => e.type === 'type').length > 0}"
                      class="absolute pt-1 text-[10px] font-normal text-zt-more">
                  Zakłady oddziel plusami (+)
                </span>
                <span v-if="!isBetbuilder" class="absolute error-text" v-for="error in errors.filter(e => e.type === 'type')">
                  {{ error.content }}
                </span>
              </div>
            </div>
            <div v-if="!isBetDiscussion && comment_type.string !== 'Komentarz'" class="relative col-span-2 xl:col-span-1">
              <label for="rate" class="bet-element-header text-left">Kurs</label>
              <input class="min-h-[45px]" :class="[checkErrors('rate') ? ['border', 'border-[#FF1818]'] : '']"
                     type="text" id="rate" v-model="rate" placeholder="Minimalny kurs: 1.50"
                     :disabled="comment_type.string === 'Komentarz'" />
              <div class="flex flex-col">
                <span class="absolute error-text" v-for="error in errors.filter(e => e.type === 'rate')">
                  {{ error.content }}
                </span>
              </div>
            </div>
            <div v-if="!isBetDiscussion && comment_type.string !== 'Komentarz'" class="relative col-span-2 xl:col-span-1">
              <label for="hour" class="bet-element-header text-left">Godzina</label>
              <input class="min-h-[45px]" :class="[checkErrors('hour') ? ['border', 'border-[#FF1818]'] : '']"
                     type="text" id="hour" v-model="hour" placeholder="hh:mm" @input="addDotToHour"
                     :disabled="comment_type.string === 'Komentarz'" />
              <div class="flex flex-col">
                <span class="absolute error-text" v-for="error in errors.filter(e => e.type === 'hour')">
                  {{ error.content }}
                </span>
              </div>
            </div>
            <div v-if="!isBetDiscussion && comment_type.string !== 'Komentarz'" class="relative col-span-2 xl:col-span-1">
              <label class="bet-element-header text-left">Bukmacher</label>
              <FootballSelect
                  :height="45"
                  is-model-object
                  :padding="14"
                  v-model="bookmaker"
                  :default="'Wybierz bukmachera'"
                  :options="bookmakers"
              />
              <div class="flex flex-col">
                <span class="absolute error-text" v-for="error in errors.filter(e => e.type === 'bookmaker')">
                  {{ error.content }}
                </span>
              </div>
            </div>

            <div v-if="!isBetDiscussion && userCanAddCommentTypeBet"
                 :class="[comment_type.string === 'Typ-Reklama' || comment_type.string === 'Komentarz' || window.size.mobile
                   ? 'col-span-2' : 'col-span-1']">
              <label class="bet-element-header text-left">Rodzaj</label>
              <FootballSelect
                  :height="45"
                  is-model-object
                  v-model="comment_type"
                  :default="'Typ'"
                  :padding="14"
                  :options="['Typ', 'Typ-Reklama', 'Komentarz']"
              />
            </div>

            <div
              v-if="!isBetDiscussion && userCanAddCommentTypeBet && comment_type.string !== 'Typ-Reklama'
                    && comment_type.string !== 'Komentarz'"
              class="relative col-span-2 xl:col-span-1"
              :class="[comment_type.string === 'Typ-Reklama' || comment_type.string === 'Komentarz' || window.size.mobile
                ? 'col-span-2' : 'col-span-1']"
              v-click-outside="() => { this.searchUserInputFocus = false; }">
              <label for="user" class="bet-element-header text-left">Użytkownik</label>
              <input class="min-h-[45px]" autocomplete="off" type="text" id="user" v-model="searchUserInput"
                     @change="resetSearchUser" @focus="searchUserInputFocus = true; searchUserInputGetData();" />
              <div v-if="searchUserInputFocus"
                   class="dropdown-menu absolute -translate-y-1 bg-zt-normal z-50 pt-2 list-none rounded-b-xl shadow-zt text-text
                     w-full max-h-[250px] overflow-y-auto"
                   @scroll="scrollUserList">
                <div v-for="user in searchedUsers.slice(0, amountShown)"
                     class="flex flex-row items-center mb-2 justify-between text-[12px] cursor-pointer hover:bg-zt-main">
                  <div class="flex-col shrink-0">
                    <div @click="setUser(user)">
                      <img :src="user.avatar" alt="Avatar" @error="handleUserAvatarError($event)"
                           class="border-2 border-transparent shadow-lg box-border cursor-pointer h-[32px] w-[32px]
                             transition-all rounded-full xl:w-[54px] xl:h-[54px]"/>
                    </div>
                  </div>
                  <div class="flex-col whitespace-nowrap overflow-hidden overflow-ellipsis mx-2 grow text-left xl:text-[18px]">
                    <div @click="setUser(user)">
                      <span class="overflow-ellipsis">{{ user.display_name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="comment_type.string === 'Typ' || comment_type.string === 'Wpis dyskusyjny'"
                 class="relative col-span-2 text-left">
              <label class="bet-element-header">{{ isBetDiscussion ? 'Treść' : 'Analiza' }}</label>
              <textarea class="py-2"
                        v-model="analysis"
                        :rows="window.size.mobile
                          ? isBetDiscussion ? 18 : 12
                          : isBetDiscussion ? 8 : 6"
                        :class="[checkErrors('analysis') ? ['border', 'border-[#FF1818]'] : '']"
                        :placeholder="isBetDiscussion ? 'Treść wpisu' : 'Napisz analizę (min. 150 znaków)'">
              </textarea>
              <div class="absolute flex flex-col -mr-1">
                <span class="error-text" v-for="error in errors.filter(e => e.type === 'analysis')">{{ error.content }}</span>
              </div>
            </div>

            <div v-if="comment_type.string === 'Typ-Reklama' || comment_type.string === 'Komentarz'"
                 class="col-span-2 text-left">
              <label class="text-[14px]">Treść bonusu</label>
              <TinyMCE v-model="analysis"
                       :init="{
                        license_key: 'gpl',
                        height: 450,
                        menubar: false,
                        file_picker_types: 'image',
                        automatic_uploads: true,
                        images_upload_credentials : true,
                        image_title: true,
                        images_upload_handler: image_upload_handler,
                        block_unsupported_drop: false,
                        images_upload_url: this.WP.slowAjaxUrl,
                        file_picker_callback: custom_callback,
                        paste_preprocess: (plugin, args) => {
                          const conditions = ['svg', 'png', 'img']
                          if(conditions.some(el => args.content.includes(el))){
                            args.content = '';
                          }
                        },
                        content_css: false,
                        skin: false,
                        content_style: 'body { font-family:Poppins,Arial,sans-serif; font-size:16px }',
                        plugins: [
                          'autolink', 'lists', 'advlist', 'link', 'image', 'charmap', 'preview', 'anchor',
                          'visualblocks', 'code', 'fullscreen',
                          'media', 'table', 'code', 'wordcount',
                        ],
                        toolbar:
                          'undo redo | image link | formatselect | bold italic underline backcolor forecolor | \
                          fontsize | alignleft aligncenter alignright alignjustify | \
                          bullist numlist | code | removeformat '
                       }"
              />
            </div>

            <div v-if="comment_type.string === 'Typ-Reklama' || comment_type.string === 'Komentarz'"
                 class="col-span-2 text-left">
              <label class="text-[14px]">Zasady bonusu</label>
              <TinyMCE v-model="rules"
                       :init="{
                        license_key: 'gpl',
                        height: 450,
                        menubar: false,
                        content_css: false,
                        skin: false,
                        content_style: 'body { font-family:Poppins,Arial,sans-serif; font-size:16px }',
                        plugins: [
                          'autolink', 'lists', 'advlist', 'link', 'image', 'charmap', 'preview', 'anchor',
                          'visualblocks', 'code', 'fullscreen',
                          'media', 'table', 'code', 'wordcount'
                        ],
                        toolbar:
                          'undo redo | image link | formatselect | bold italic underline backcolor forecolor | \
                          fontsize | alignleft aligncenter alignright alignjustify | \
                          bullist numlist | code | removeformat '
                       }"
              />
            </div>

            <div v-if="comment_type.string === 'Typ-Reklama' || comment_type.string === 'Komentarz'" class="col-span-2">
              <label for="advert-publish-date" class="bet-element-header">
                Data planowanej publikacji
                <span class="font-light">(pozostaw puste, jeśli chcesz opublikować teraz)</span>
              </label>
              <input type="datetime-local" id="advert-publish-date" v-model="publishDate" class="!w-fit min-h-[45px]">
            </div>

            <div v-if="!isBetDiscussion" class="col-span-2 text-left">
              <label for="link" class="bet-element-header">
                {{ comment_type.string === 'Typ-Reklama' ? 'Link do bukmachera (reflink)' : 'Link do wydarzenia (opcjonalnie)' }}
              </label>
              <input class="min-h-[45px]" type="text" id="link" v-model="link"
                     :placeholder="comment_type.string === 'Typ-Reklama' ? '' : 'Link do meczu np. z Flashscore, Sofascore...'" />
            </div>
          </div>
        </div>
        <button class="zt-button w-full h-[40px] flex items-center justify-center mx-auto mt-6 mb-4 xl:w-[330px]"
                :class="{ '!bg-[#B5B5B5]': comment_type.string === 'Typ' && checkBetCountByDay(this.dateOffset) >= 2 }"
                @click.stop="validateFormAndAddCommentOrBet">
              <span class="text-[14px]"
                    :class="[comment_type.string !== 'Typ' || checkBetCountByDay(this.dateOffset) < 2 ? '' : 'opacity-50']">
                DODAJ {{ isBetDiscussion ? 'WPIS' : comment_type.string.toUpperCase() }}
              </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin';
import { Notice } from '../../../assets/js/Notice';
import FormSelect from '../FormSelect.vue';
import ConfirmationModal from './ConfirmationModal.vue';
import { isPhraseOffensive } from '../../../assets/js/frontend-black-list';
import TinyMCE from '../TinyMCE.vue';
import FootballSelect from "../FootballSelect.vue";

export default {
  name: "addBetForm",
  inject: ['WP'],
  mixins: [utils_mixin],
  components: {
    FootballSelect,
    ConfirmationModal,
    FormSelect,
    TinyMCE,
  },
  props: {
    userAddingOnAnotherPage: Object,
    isBetDiscussion: Boolean,
    isAddBetDiscussionAllowed: Number
  },
  emits: ['close', 'end', 'addbet'],
  data() {
    return {
      disciplines: [
        { title: 'Piłka nożna', search: true, index: 0 },
        { title: 'Tenis', search: true, index: 1 },
        { title: 'Hokej', search: true, index: 2 },
        { title: 'Koszykówka', search: true, index: 3 },
        { title: 'Siatkówka', search: true, index: 4 },
        { title: 'Sporty motorowe', search: true, index: 24 },
        { title: 'Sporty walki', search: true, index: 5 },
        { title: 'Sporty zimowe', search: true, index: 6 },
        { title: 'Baseball', search: true, index: 9 },
        { title: 'E-sport', search: true, index: 11 },
        { title: 'Piłka ręczna', search: true, index: 19 },
        { title: 'Dart', search: true, index: 10 },
        { title: 'Żużel', search: true, index: -1 },
        { title: 'Inna', search: true, index: null }
      ],
      bookmakers: [
        'Fortuna', 'LVBET', 'eWinner', 'Betfan', 'Betclic', 'Totolotek', 'forBET', 'PZBuk', 'Betcris', 'STS',
        'Goplusbet', 'Superbet', 'TOTALbet', 'Fuksiarz', 'ETOTO', 'BetX', 'Betters', 'Noblebet', 'ComeOn',
        'AdmiralBet', 'WettArena', 'Lebull',
      ],
      name: 'AddBet',
      analysis: '',
      rate: '',
      hour: '',
      bookmaker: { string: '' },
      discipline: { string: '' },
      type: '',
      match_name: '',
      errors: [],
      rules: '',
      link: '',
      dateOffset: -1,
      isDateModalOpen: false,
      comment_type: this.isBetDiscussion ? { string: 'Wpis dyskusyjny' } : { string: 'Typ' },
      searchUserId: null,
      searchUserInput: '',
      searchUserInputFocus: false,
	    searchUserAvatar: '',
      usersList: [],
      userCanAddCommentTypeBet: false,
      amountShown: 10,
      usersLoaded: false,
      lastBetTimestamp: 0,
      bets: [],
      isConfirmationModalOpen: false,
      secondsSinceLastActivity: 0,
      secondsSinceFormOpening: 0,
      interval: null,
      clickOutside: {
        handler: (e) => {
          if (!e.target.closest('.preventCloseParentModal')) {
              this.openConfirmationModal(e);
          }
        },
        events: ['touchend', 'mousedown']
      },
      publishDate: '',
      isBetbuilder: false
    };
  },
  computed: {
    searchedUsers() {
      if (this.searchUserInput.length === 0) {
        return this.usersList;
      }

      if (this.usersList !== null) {
        return this.usersList.filter(user => {
          return user.display_name.toLowerCase().replace(/\s/g, '')
            .includes(this.searchUserInput.toLowerCase().replace(/\s/g, ''));
        });
      }
    },
    isUserAddingOnAnotherPage() {
      return this.userAddingOnAnotherPage.isAdding;
    }
  },
  mounted() {
    this.blockScrolling();
    this.userCanAddCommentTypeBet = this.WP.user.role === 'Admin' || this.WP.user.role === 'Moderator' || this.WP.user.role === 'Redaktor';
    this.getUserPlannedBets(this.WP.user.id);

    document.body.addEventListener('mouseover', this.zeroTimeSinceLastActivity);
    document.body.addEventListener('scroll', this.zeroTimeSinceLastActivity, { passive: true });
    document.body.addEventListener('keydown', this.zeroTimeSinceLastActivity);
    this.interval = setInterval(() => {
      this.secondsSinceLastActivity++;
      this.secondsSinceFormOpening++;
      this.addingBetUserHeartbeat();
    }, 1000);
    window.addEventListener('pagehide', this.beforeUnloadListener);
  },
  unmounted() {
    this.unblockScrolling();
    this.removeBeforeUnloadListener();
  },
  methods: {
    addDotToHour(event) {
      if (this.hour.length === 2 && event.inputType !== 'deleteContentBackward') {
        this.hour += ':';
      }
    },
    removeBeforeUnloadListener() {
      window.removeEventListener('pagehide', this.beforeUnloadListener);
    },
    beforeUnloadListener(event) {
      if (this.hasSomethingChanged()) {
        event.preventDefault();
      }
    },
    image_upload_handler(blobInfo, progress) {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append('endpoint', 'api_upload_image');
        formData.append('file', blobInfo.blob());
        const config = {
          onUploadProgress: progressEvent => progress(Math.round((progressEvent.loaded * 100) / progressEvent.total))
        };
        axios
          .post(this.WP.slowAjaxUrl, formData, config)
          .then(response => {
            if (response.data.success) {
              resolve(response.data.data);
            } else {
              reject();
            }
          });
      });
    },
    custom_callback(cb, value, meta) {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');

      input.addEventListener('change', (e) => {
        const file = e.target.files[0];

        const reader = new FileReader();
        reader.addEventListener('load', () => {
          const id = 'blobid' + (new Date()).getTime();
          const blobCache =  tinymce.activeEditor.editorUpload.blobCache;
          const base64 = reader.result.split(',')[1];
          const blobInfo = blobCache.create(id, file, base64);
          blobCache.add(blobInfo);
          cb(blobInfo.blobUri(), { title: file.name });
        });
        reader.readAsDataURL(file);
      });
      input.click();
    },
    setUser(user) {
      this.searchUserInputFocus = false;
      this.searchUserInput = user.display_name;
      this.searchUserId = user.ID;
			this.searchUserAvatar = user.avatar;
      this.getUserPlannedBets(user.ID);
    },
    getUsers() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_get_all_users'
        })
        .then(response => {
          if (response.data.success) {
            this.usersLoaded = true;
            this.usersList = response.data.data;
          }
        });
    },
    parseDate(offset) {
      let date = new Date();
      date.setDate(date.getDate() + offset);
      date = this.DateTime.fromJSDate(date);
      return window.size.mobile ? date.toFormat('ccc, d LLL') : date.toFormat('cccc, d LLL');
    },
    setBetDate(offset) {
      if (this.comment_type.string === 'Typ-Reklama' || this.comment_type.string === 'Komentarz'
        || this.checkBetCountByDay(offset) < 2) {
        this.dateOffset = offset;
        this.isDateModalOpen = false;
      }
    },
    validateFormAndAddCommentOrBet(e) {
      e.preventDefault();

      this.errors = [];

      if (this.comment_type.string !== 'Komentarz') {
        if (this.comment_type.string === 'Wpis dyskusyjny') {
          this.validateBetDiscussion();
        } else {
          this.validateBet();
        }
      } else {
        this.validateDateOffset();
      }

      if (this.errors.length === 0) {
        this.addBet();
      }
    },
    validateBetDiscussion() {
      this.analysis = this.analysis.trim();
      const temp_analysis = this.analysis.replace(/[^a-zA-Z0-9]/g, "");
      if (!temp_analysis || temp_analysis.length < 100) {
        this.pushError('analysis', 'Treść wpisu musi składać się z przynajmniej 100 znaków!');
      } else if (temp_analysis.length > 2000) {
        this.pushError('analysis', 'Treść wpisu nie może przekraczać 2000 znaków!');
      } else if (isPhraseOffensive(temp_analysis)) {
        this.pushError('analysis', 'Treść wpisu zawiera zakazane słowa.');
      }
      this.validateDateOffset();
    },
    validateBet() {
      if (this.comment_type.string !== 'Typ-Reklama') {
        this.analysis = this.analysis.trim();
        const temp_analysis = this.analysis.replace(/[^a-zA-Z0-9]/g, "");
        if (!temp_analysis || temp_analysis.length < 150) {
          this.pushError('analysis', 'Analiza musi składać się z przynajmniej 150 znaków!');
        }
      }
      this.validateHour();
      this.validateBookmaker();
      this.validateDiscipline();
      this.validateType();
      this.validateMatchName();
      this.validateDateOffset();
      this.validateRate();
      this.validateMatchAndType();
    },
    validateHour() {
      if (!this.hour) {
        this.pushError('hour', 'Godzina wymagana!');
      } else if (!this.validateHourFormat(this.hour)) {
        this.pushError('hour', 'Godzina musi być w formacie HH:mm!');
      }
    },
    validateHourFormat(hourString) {
      return /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(hourString);
    },
    validateBookmaker() {
      if (this.bookmaker.string === 'Wybierz bukmachera') {
        this.pushError('bookmaker', 'Bukmacher wymagany!');
      }
    },
    validateDiscipline() {
      if (this.discipline.string === 'Wybierz dyscyplinę') {
        this.pushError('discipline', 'Dyscyplina wymagana!');
      }
    },
    validateType() {
      if (!this.type) {
        this.pushError('type', 'Typ wymagany!');
        return;
      }
      if ((this.type.toLowerCase().includes('betbuilder') || this.type.toLowerCase().includes('builder')) && !this.isBetbuilder) {
        this.pushError('type', `Zaznacz na górze "Betbuilder"`);
        return;
      }
      if (this.isBetbuilder && !this.type.includes('+')) {
        this.pushError('type', '');
      }
    },
    validateMatchName() {
      if (!this.match_name) {
        this.pushError('name', 'Nazwa wydarzenia wymagana!');
      }
    },
    validateDateOffset() {
      if (this.dateOffset === -1) {
        this.pushError('date', 'Wskazanie dnia jest wymagane!');
      }
    },
    validateRate() {
      this.rate = this.rate.replace(',', '.');
      if (!this.rate) {
        this.pushError('rate', 'Kurs wymagany!');
      } else if (this.rate <= 0) {
        this.pushError('rate', 'Kurs musi być dodatni!');
      } else if (this.rate < 1.5) {
        this.pushError('rate', 'Kurs minimalny wynosi 1.50!');
      } else if (isNaN(Number(this.rate))) {
        this.pushError('rate', 'Podano nieprawidłowy kurs!');
      }
    },
    validateMatchAndType() {
      if (this.checkMatchAndType(this.match_name, this.type)) {
        this.pushError('name-type', 'Typy podajemy z regularnej oferty bukmachera. Wykluczamy superoferty, mega kursy, podwyższone kursy z promocji, a także betbuilder, betarchitekt, custombet i inne zakłady na żądanie!');
      }
    },
    pushError(type, content) {
      this.errors.push({ type, content });
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_save_bet_add_modal_error',
          error_type: type,
        });
    },
    checkMatchAndType(matchIn, typeIn) {
      let match = matchIn.replace(' ', '').toLowerCase();
      let type = typeIn.replace(' ', '').toLowerCase();
      if (match === 'betbuilder' || match === 'betarchitekt' || match === 'custombet') {
        return true;
      }
      return type === 'betbuilder' || type === 'betarchitekt' || type === 'custombet';
    },
    checkErrors(type) {
      return this.errors.some(e => e.type === type);
    },
    scrollUserList(event) {
      if (event.target.offsetHeight + event.target.scrollTop + 30 >= event.target.scrollHeight
        && this.amountShown < this.searchedUsers.length) {
        this.amountShown += 10;
      }
    },
    searchUserInputGetData() {
      if (this.usersLoaded === false) {
        this.getUsers();
      }
    },
    addBet() {
      if (this.lastBetTimestamp && this.DateTime.now().toSeconds() - this.lastBetTimestamp < 10) {
        this.addInternalNotification(new Notice().setContent('Odczekaj chwilę, zanim dodasz kolejny typ'));
        return;
      }
      this.lastBetTimestamp = this.DateTime.now().toSeconds();
      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_add_bet',
          discipline: (this.discipline.string === 'Wybierz dyscyplinę' ? '' : this.discipline.string),
          rate: Number(this.rate),
          date_offset: this.dateOffset + "day",
          hour: this.hour,
          bookmaker: (this.bookmaker.string === 'Wybierz bukmachera' ? '' : this.bookmaker.string),
          content: (this.comment_type.string === 'Typ-Reklama' || this.comment_type.string === 'Komentarz')
            ? this.analysis.concat('rules::', this.rules, 'link::', this.link) : this.analysis,
          match_name: this.match_name,
          type: this.type,
          comment_type: this.isBetDiscussion
            ? 'betDiscussion'
            : (this.comment_type.string === 'Typ-Reklama' || this.comment_type.string === 'Komentarz')
              ? 'advert' : 'bet',
          user_id: this.searchUserId ? this.searchUserId : null,
          link: this.link,
          is_bet_discussion_allowed: this.isAddBetDiscussionAllowed,
          publish_date: this.publishDate,
          is_betbuilder: this.isBetbuilder
        })
        .then(response => {
          if (response.data.success) {
            if (response.data.data.advert_planned) {
              this.closeModal();
              this.addInternalNotification(new Notice()
                .setContent(response.data.data.message));
              return;
            }
						if (response.data.data.bet.comment_approved) {
							const notificationsData = response.data.data.notification;
							for (let i = 0; i < notificationsData.followers.length; i++) {
								const follower = notificationsData.followers[i];
								const data = {
									id: notificationsData.ids[i],
									recipientId: +follower.id,
									comment_id: notificationsData.comment_id.toString(),
									post_id: notificationsData.post_id.toString(),
									sender_id: notificationsData.sender_id.toString(),
									seen: '0',
									created_at: DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss'),
									type: notificationsData.type,
                  content: response.data.data.bet.comment_type === 'bet' ? this.match_name : this.analysis,
									sender_avatar: this.searchUserId ? this.searchUserAvatar : this.WP.user.avatar,
									sender_name: this.searchUserId ? this.searchUserInput : this.WP.user.name
								};
								socket?.emit('notify-user', data);
							}
						}
            if (this.isBetDiscussion) {
              socket?.emit('new-bet-discussion', response.data.data.bet);
            } else if (!response.data.data.bet.past_date) {
              socket?.emit('new-bet', response.data.data.bet);
            }
            this.$emit('addbet', response.data.data.bet);
            if (this.WP.id !== response.data.data.bet.post_id) {
              this.removeBeforeUnloadListener();
              window.location = `/?p=${response.data.data.bet.post_id}/#comment-${response.data.data.bet.comment_id}`;
            }
            this.closeModal();
          } else {
            this.addInternalNotification(new Notice()
              .setContent(response.data.data));
          }
        })
        .catch(error => {
          this.addInternalNotification(new Notice()
            .setContent(error.response.data.data));
        });
    },
    hourBetween21and24() {
      const date = new Date();
      return date.getHours() >= 21 && date.getHours() < 24;
    },
    getUserPlannedBets(userId) {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_get_user_planned_bets',
          user_id: userId,
        })
        .then(response => {
          if (response.data.success) {
            this.bets = response.data.data;
          }
        });
    },
    checkBetCountByDay(dayOffset) {
      if (this.bets.length > 0) {
        let today = this.DateTime.now();
        today = today.plus({ days: dayOffset });

        return this.bets.filter(b => {
          let bet_day = this.DateTime.fromSQL(b.bet_day);
          return bet_day.hasSame(today, 'day') && b.comment_type === (this.isBetDiscussion ? 'betDiscussion' : 'bet');
        }).length;
      } else {
        return 0;
      }
    },
    hasSomethingChanged() {
      if (this.isBetDiscussion) {
        if (this.analysis === '') {
          return false;
        }
      } else {
        if (this.analysis === '' && this.rate === '' && this.hour === '' && this.bookmaker.string === 'Wybierz bukmachera'
          && this.discipline.string === 'Wybierz dyscyplinę' && this.type === '' && this.match_name === '' && this.rules === ''
          && this.link === '') {
          return false;
        }
      }
      return true;
    },
    openConfirmationModal(e) {
      // klikanie w elementy z tinymce
      if (e?.target.closest('[role="menu"]') || e?.target.closest('[role="toolbar"]') || e?.target.closest('[role="dialog"]') ||
          e?.target.closest('[role="presentation"]')) {
        return;
      }

      if (!this.hasSomethingChanged()) {
        this.closeModal();
        return;
      }

      this.isConfirmationModalOpen = true;
    },
    clearForm() {
      this.analysis = '';
      this.rate = '';
      this.hour = '';
      this.type = '';
      this.match_name = '';
      this.rules = '';
      this.link = '';
    },
    zeroTimeSinceLastActivity() {
      this.secondsSinceLastActivity = 0;
      if (this.interval === null) {
        this.interval = setInterval(() => {
          this.secondsSinceLastActivity++;
          this.secondsSinceFormOpening++;
          this.addingBetUserHeartbeat();
        }, 1000);
      }
    },
    emitAddingBetSocket() {
      socket?.emit('adding-bet-add', {
        postId: Number(this.WP.id),
        username: this.WP.user.name,
        userId: this.WP.user.id,
        avatar: this.WP.user.avatar
      });
    },
    emitAddingBetSocketRemove() {
      socket?.emit('adding-bet-remove', {
        postId: Number(this.WP.id),
        username: this.WP.user.name.split(' ')[0],
        userId: this.WP.user.id
      });
    },
    emitAddingBetDiscussionSocket() {
      socket?.emit('adding-bet-discussion-add', {
        postId: Number(this.WP.id),
        username: this.WP.user.name,
        userId: this.WP.user.id,
        avatar: this.WP.user.avatar
      });
    },
    emitAddingBetDiscussionSocketRemove() {
      socket?.emit('adding-bet-discussion-remove', {
        postId: Number(this.WP.id),
        username: this.WP.user.name.split(' ')[0],
        userId: this.WP.user.id
      });
    },
    addingBetUserHeartbeat() {
      if (this.secondsSinceLastActivity >= 30) {
        clearInterval(this.interval);
        this.interval = null;
        if (!this.isUserAddingOnAnotherPage) {
          if (this.isBetDiscussion) {
            this.emitAddingBetDiscussionSocketRemove();
          } else {
            this.emitAddingBetSocketRemove();
          }
        }
      } else if (this.secondsSinceFormOpening >= 10 && this.analysis.length > 20) {
        if (this.isBetDiscussion) {
          this.emitAddingBetDiscussionSocket();
        } else {
          this.emitAddingBetSocket();
        }
      }
    },
    closeModal() {
      clearInterval(this.interval);
      this.clearForm();
      this.interval = null;
      this.secondsSinceLastActivity = 0;
      this.secondsSinceFormOpening = 0;
      if (!this.isUserAddingOnAnotherPage) {
        if (this.isBetDiscussion) {
          this.emitAddingBetDiscussionSocketRemove();
        } else {
          this.emitAddingBetSocketRemove();
        }
      }
      this.$emit('close');
    },
    resetSearchUser() {
      if (this.searchUserInput === '') {
        this.getUserPlannedBets(this.WP.user.id);
      }
    },
    hideTooltip(event) {
      for (const element of event.composedPath()) {
        if (typeof element === 'object' && element !== null && 'getAttribute' in element && element.hasAttributes()) {
          for (const attr of element.attributes) {
            if (attr.name === 'data-tooltip-created') {
              setTimeout(() => {
                let tooltip = Tooltip.getInstance(element);
                tooltip.hide();
              }, 300000);
              return;
            }
          }
        }
      }
    }
  }
};
</script>

<style scoped>
.date-modal:after {
  content: '';
  position: absolute;
  top: -10px;
  right: 10px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 16px solid #28333e;
}
.bet-element-header {
  @apply text-[14px] font-semibold ml-1 mb-1.5 block;
}
.date-modal {
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
}
.date-modal div {
  @apply px-3 py-2 text-[12px] border-b-[1px] border-[#1F272F] cursor-pointer last:border-b-0 first:cursor-default hover:bg-zt-light first:hover:bg-zt-normal;
}

.error-text {
  @apply text-[12px] text-[#F00];
}

.tooltip {
  @apply z-modal !important;
}

</style>